module.exports = __webpack_public_path__ + "img/artnhealing_option_06.5da57c24.jpg";